import React from 'react'
import { useTranslation } from 'react-i18next'
import Page from '../Page'
import useStyles from './styles'

export const AfterBookingFallback = () => {
  const classes = useStyles()
  const { t } = useTranslation()

  return <Page body={<div className={classes.text}>{t('after_booking_fallback_error_message')}</div>} />
}
